import * as React from 'react';
import styled from 'styled-components';
import { forTablet } from '@westwing/ui-kit/breakPoints';
import useQuestionnaireFlow from '@ids/hooks/useQuestionnaireFlow';
import { useFeatureToggle } from '@ids/appshell';
import StyledActionButton from '@ids/components/ActionButton/ActionButton';

const StyledCTAButton = styled(StyledActionButton)`
    ${forTablet`
        height: 44px;
    `}
`;

interface ButtonProps extends React.HTMLAttributes<HTMLButtonElement> {
    children?: React.ReactNode;
}

const CTAButton = ({ children, onClick, ...buttonProps }: ButtonProps) => {
    const { p100StudioPriceTiers } = useFeatureToggle();
    const { startQuestionnaire } = useQuestionnaireFlow();

    const handleCTAButtonClick = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        if (onClick) {
            onClick(event);
        }

        if (p100StudioPriceTiers) {
            document.getElementById('price-tiers')?.scrollIntoView({ behavior: 'smooth' });
        } else {
            startQuestionnaire();
        }
    };

    return (
        <StyledCTAButton onClick={handleCTAButtonClick} {...buttonProps}>
            {children}
        </StyledCTAButton>
    );
};

export default CTAButton;
